import * as React from 'react';

export const GreenTick = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="11" viewBox="0 0 15 11">
    <path
      fill="#2E9E00"
      fillRule="nonzero"
      d="M1.707 4.924A1 1 0 0 0 .293 6.338L5 11.046l9.338-9.339A1 1 0 0 0 12.924.293L5 8.217 1.707 4.924z"
    />
  </svg>
);
